jQuery(document).ready(function($){
    $(".new_row img").each(function(){
      var width = $(this).width();
      var height = $(this).height();
      if(width>height){
        $(this).parent().addClass("landscape");
      }
      else {
        $(this).parent().addClass("portrait");
      }
    });    
    
    
    var offsetWidth;
    setTimeout(function() {
      var offsetWidth = $('#shopify-section-header').width() + 'px';
      $(':root').css('--header-width', offsetWidth);
    },1000);
  
    $(window).resize(function(){
      var offsetWidth = $('#shopify-section-header').width() + 'px';
      $(':root').css('--header-width', offsetWidth);
    });
      
    
    var searchInput = $('input[type="search"]');
    var searchButton = $('.header-search-button');
    
    if (searchInput.val() == "")searchInput.hide();
    searchButton.on('click', function() {
      searchInput.fadeToggle(200,'linear', function() {
         $(this).focus();
      });
    });
    
    searchInput.focusout(function() { 
      ($(this).val() == "") ? $(this).fadeOut(200,'linear') : ''; 
    });
  
  
     $(".sidebar-filter-toggle").click(function(){
//         console.log('test');
          $('.sidebar-filter').addClass('active');
     });
     $(".sidebar-filter-close").click(function(){
//         console.log('test');
          $('.sidebar-filter').removeClass('active');
     });

  });
  
    
    
  // //  Logo List Section - Carousel/Slider
  //    	var logoListContainer = $('.shopify-section--logo-list');
  //      var sliderElement = $('.logo-list--slider .about-carousel');
  //   var itemsPerRow = $(sliderElement+'[slider-itemsPerRow]');
  //     var rowsToShow = $(sliderElement+'[rows-to-show]');
  //    //console.log(sliderElement.text());
  //   setTimeout(function() {  
  //     console.log("- Per row: " + itemsPerRow + "- Rows: "+ rowsToShow);
  //    },1000);
    
  //   setTimeout(function() {
  //     var slider = sliderElement.slick("getSlick");
      
  //     if (slider != undefined && slider != null) {
  //       slider.slickSetOption({"rows": 2,"refresh": true});
  //       slider.slickSetOption({"slidesPerRow": 10, "refresh": true});
  //     }
      
  //     console.log(slider.slickGetOption("rows"));
  //   },1000);
    
  
  